<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Lote de Distribuição | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
					<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="dt_agendada">Ponto de Apoio: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.cd_ponto_apoio }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="dt_agendada">Data: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.dt_distribuicao }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="status_desc">Status: &nbsp;&nbsp;&nbsp;</label>
              <span class="label" v-bind:class="{
                  'label-info': registro.idc_status === 1,
                  'label-warning': registro.idc_status === 2,
                  'label-success': registro.idc_status === 3,
                  'label-default': ![1,2,3].includes(registro.idc_status)
                }">{{ registro.status_desc }}</span>
            </div>
          </div>

          <br/>

          <div class="box box-primary">
            <div class="box-header">
              <div class="col-6 col-md-6 col-sm-8 col-xs-8">
                <i class="fas fa-clipboard"></i>
                <h3 class="box-title">Equipamentos</h3>
              </div>
            </div>

            <div class="box-body">
              <div class="row" v-show="registro.lote_equipamentos.length > 0" style="border-bottom: 1px solid #e9e9e9; margin: 0;">
                <div class="form-group col-3 col-md-3 col-sm-3 col-xs-6"><b>Código</b></div>
                <div class="form-group col-3 col-md-3 col-sm-3 col-xs-6"><b>Código Player</b></div>
                <div class="form-group col-3 col-md-3 col-sm-3 col-xs-6"><b>Serial</b></div>
                <div class="form-group col-3 col-md-3 col-sm-3 col-xs-6"><b>Status</b></div>
              </div>
              <div class="row" v-for="item in registro.lote_equipamentos" v-bind:key="item.cd_equipamento" style="border-bottom: 1px solid #e9e9e9; margin: 0; padding: 6px;">
                <div class="form-group col-3 col-md-3 col-sm-3 col-xs-6" style="margin-bottom: 0">{{ item.cd_equipamento }}</div>
                <div class="form-group col-3 col-md-3 col-sm-3 col-xs-6" style="margin-bottom: 0">{{ item.cd_player }}</div>
                <div class="form-group col-3 col-md-3 col-sm-3 col-xs-6" style="margin-bottom: 0">{{ item.numero_serial }}</div>
                <div class="form-group col-3 col-md-3 col-sm-3 col-xs-6" style="margin-bottom: 0">{{ item.status_desc }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Voltar</button>
            <button type="button" class="btn btn-success" @click="enviarEntrega()" v-show="registro.idc_status === 1">Enviar p/ Entrega</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DistribuicaoLoteActions from '../../actions/DistribuicaoLoteActions'
import moment from 'moment'

export default {
  name: 'detalhes',
  props: ['id'],
  data () {
    return {
      errorMessage: '',
      registro: {
        cd_lote: '',
        cd_ponto_apoio: '',
        idc_status: '',
        dt_distribuicao: '',
        status_desc: '',
        lote_equipamentos: []
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Detalhes'

    this.obterRegistro()
  },
  methods: {
    voltar () {
      this.$router.push((this.$route.query.ret_url ? this.$route.query.ret_url : '/distribuicao-equipamentos'))
    },
    obterRegistro () {
      DistribuicaoLoteActions.obter(this.id)
        .then(res => {
          if (res && res.cd_lote) {
            this.registro = res

            if (this.registro.dt_distribuicao !== null) {
              this.registro.dt_distribuicao = moment.utc(this.registro.dt_distribuicao).format('DD/MM/YYYY')
            }

            DistribuicaoLoteActions.listarEquipamentosLote(this.id)
              .then(equipamentos => {
                if (equipamentos && equipamentos.length > 0) {
                  this.registro.lote_equipamentos = equipamentos
                }
              })
              .catch((error) => {
                console.log(error.message)
              })
          } else {
            this.errorMessage = 'Registro não encontrado.'
          }
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage = 'Registro não encontrado.'
        })
    },
    enviarEntrega () {
      if (confirm('Deseja realmente enviar este lote p/ entrega?')) {
        this.$parent.$parent.$data.showModalLoader = true

        DistribuicaoLoteActions.alterarStatusParaSaiuParaEntrega(this.id)
          .then(res => {
            if (res && res.data) {
              this.$parent.$parent.$data.showModalLoader = false
              this.obterRegistro()
            }
          })
          .catch((error) => {
            console.log(error.message)
            this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
            this.$parent.$parent.$data.showModalLoader = false
          })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/distribuicao-equipamentos/Detalhes.vue